module.exports = __webpack_public_path__ + "static/media/financial-accounting-not-enrolled.8c5e3e71.svg";